<template>
  <div class="partner">
    <div class="partnet-box">
      <div class="title">
        <div class="partner-title">
          <span>合作伙伴</span>
          <div class="" style="text-decoration: none; font-size: 32px; display: inline-block; float: right; margin-right: 3px; line-height: 50px; height: 50px; font-weight: 550; color: rgb(21, 14, 82); position: absolute; right: 0px; top: 0px;">
            <div class="partner-right__btn">
              <span class="partner-right__btn-left">
                <i class="el-icon-arrow-left"></i>
              </span>
              <span class="partner-right__btn-right">
                <i class="el-icon-arrow-right"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="content">
        <swiper ref="mySwiper" class="swiper" :options="swiperOptions">
          <swiper-slide v-for="(item, index) in partnersImages" :key="index">
            <img width="200" :src="item.src" :alt="item.alt" >
          </swiper-slide>
        </swiper>
      </div>
    </div>
  </div>
</template>
<script>
import 'swiper/css/swiper.css'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
export default {
  name: "partner",
  components: {
    Swiper, SwiperSlide
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: 5,
        slidesPerColumn: 2,
        spaceBetween: 30,
        pagination: {
          clickable: true
        },
        navigation: {
          prevEl: '.partner-right__btn-left',
          nextEl: '.partner-right__btn-right',
        },
      },
      partnersImages: [
        {
          src: 'https://cultureexpo-prod-1302844417.cos.ap-guangzhou.myqcloud.com//images/web/home/hezuo-3dExhibition.jpg',
          alt: '视创云度',
        },
        {
          src: 'https://cultureexpo-prod-1302844417.cos.ap-guangzhou.myqcloud.com//images/web/home/hezuo%20(9).png',
          alt: '深圳日报',
        },
        {
          src: 'https://cultureexpo-prod-1302844417.cos.ap-guangzhou.myqcloud.com//images/web/home/hezuo%20(14).png',
          alt: '腾讯云',
        },
        {
          src: 'https://cultureexpo-prod-1302844417.cos.ap-guangzhou.myqcloud.com//images/web/home/hezuo%20(15).png',
          alt: '一帆展览',
        },
        {
          src: 'https://cultureexpo-prod-1302844417.cos.ap-guangzhou.myqcloud.com//images/web/home/hezuo%20(1).png',
          alt: '中国文化产业网',
        },
        {
          src: 'https://cultureexpo-prod-1302844417.cos.ap-guangzhou.myqcloud.com//images/web/home/hezuo-3dExhibition.jpg',
          alt: '视创云度',
        },
        {
          src: 'https://cultureexpo-prod-1302844417.cos.ap-guangzhou.myqcloud.com//images/web/home/hezuo%20(9).png',
          alt: '深圳日报',
        },
        {
          src: 'https://cultureexpo-prod-1302844417.cos.ap-guangzhou.myqcloud.com//images/web/home/hezuo%20(14).png',
          alt: '腾讯云',
        },
        {
          src: 'https://cultureexpo-prod-1302844417.cos.ap-guangzhou.myqcloud.com//images/web/home/hezuo%20(15).png',
          alt: '一帆展览',
        },
        {
          src: 'https://cultureexpo-prod-1302844417.cos.ap-guangzhou.myqcloud.com//images/web/home/hezuo%20(1).png',
          alt: '中国文化产业网',
        },
        {
          src: 'https://cultureexpo-prod-1302844417.cos.ap-guangzhou.myqcloud.com//images/web/home/hezuo-3dExhibition.jpg',
          alt: '视创云度',
        },
        {
          src: 'https://cultureexpo-prod-1302844417.cos.ap-guangzhou.myqcloud.com//images/web/home/hezuo%20(9).png',
          alt: '深圳日报',
        },
        {
          src: 'https://cultureexpo-prod-1302844417.cos.ap-guangzhou.myqcloud.com//images/web/home/hezuo%20(14).png',
          alt: '腾讯云',
        },
        {
          src: 'https://cultureexpo-prod-1302844417.cos.ap-guangzhou.myqcloud.com//images/web/home/hezuo%20(15).png',
          alt: '一帆展览',
        },
        {
          src: 'https://cultureexpo-prod-1302844417.cos.ap-guangzhou.myqcloud.com//images/web/home/hezuo%20(1).png',
          alt: '中国文化产业网',
        },
        {
          src: 'https://cultureexpo-prod-1302844417.cos.ap-guangzhou.myqcloud.com//images/web/home/hezuo-3dExhibition.jpg',
          alt: '视创云度',
        },
        {
          src: 'https://cultureexpo-prod-1302844417.cos.ap-guangzhou.myqcloud.com//images/web/home/hezuo%20(9).png',
          alt: '深圳日报',
        },
        {
          src: 'https://cultureexpo-prod-1302844417.cos.ap-guangzhou.myqcloud.com//images/web/home/hezuo%20(14).png',
          alt: '腾讯云',
        },
        {
          src: 'https://cultureexpo-prod-1302844417.cos.ap-guangzhou.myqcloud.com//images/web/home/hezuo%20(15).png',
          alt: '一帆展览',
        },
        {
          src: 'https://cultureexpo-prod-1302844417.cos.ap-guangzhou.myqcloud.com//images/web/home/hezuo%20(1).png',
          alt: '中国文化产业网',
        },
      ]
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    }
  },
  methods: {},
}
</script>
<style scoped>
.partner {
  width: 100%;
  height: auto;
}
.partnet-box {
  width: 1140px;
  min-width: 1140px;
  max-height: 925px;
  text-align: center;
  margin: 50px auto auto;
}
.partnet-box .content {
  margin-top: 30px;
}
.partner-title {
  margin: auto;
  font-size: 36px;
  color: #150e52;
  font-weight: 600;
}
.swiper {
  height: 300px;
  margin-left: auto;
  margin-right: auto;
}
.swiper .swiper-slide {
  height: auto;
  width: 200px !important;
}
.swiper .swiper-slide .swiper-slide-active {
  transition: none;
}
.partner-right__btn {
  font-size: 30px;
}
.partner-right__btn .partner-right__btn-left {
  margin-right: 10px;
  outline: none;
}
.partner-right__btn .partner-right__btn-right {
  margin-left: 10px;
  outline: none;
}
</style>
